module.exports = __webpack_public_path__ + "static/logo-slap-digital-blanc-74fac61fab56cd520aa827842d6d524b.png";